/* eslint-disable jsx-a11y/alt-text */
import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import first from "../../../assets/images/four1.png";
import sec from "../../../assets/images/four2.png";
import three from "../../../assets/images/four3.png";
import phone from "../../../assets/images/ans.png";
import report from "../../../assets/images/report.png";
import customer from "../../../assets/images/customer.png";
import onthe from "../../../assets/images/onthe.png";
import track from "../../../assets/images/track.png";
import line from "../../../assets/images/line.png";
import Modal from "../../../assets/modal/Modal";
import { DataItem } from "../../../common/dummydata/Dummy";
import styles from "../four/four.module.scss";

interface Iprops {
  setOpen: (newval: boolean) => void;
}

const Four = ({ setOpen }: Iprops) => {
  const [modal, setModal] = useState(false);
  const [dataMain, setData] = useState<DataItem[]>([]);
  const [selectIndex, setSelectIndex] = useState(0);
  const data: DataItem[] = [
    {
      head: "Add multiple projects and properties",
      label: "Manage your inspection needs with our Digital Platform.",
      image: phone,
    },
    {
      head: "Create appointments on the go",
      label: "Choose between a desktop or be on the move with our mobile app.",
      image: onthe,
    },
    {
      head: "Real time Tracking",
      label: "Get real time updates about how your inspection is progressing.",
      image: track,
    },
    {
      head: "Get Detailed Reporting",
      label: "Get drill down views and daily, monthly and weekly reporting.",
      image: report,
    },
    {
      head: "In App Customer Service",
      label: "Speak with a human and get help real time. ",
      image: customer,
    },
  ];
  const handleClick = (item: DataItem, index: number) => {
    setData([item]);
    setSelectIndex(index);
    setModal(true);
    setOpen(false);
  };
  useEffect(() => {
    if (modal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [modal]);
  return (
    <div className={styles.four_wrapper_main}>
      <Container>
        <div className={styles.four_Wrapper}>
          <Row className="justify-content-around gx-5">
            <>
              <Col md={12} lg={5}>
                <div className={styles.heading}>
                  <p id="manage">
                    Seamless Integrated Eco-System
                    <img src={line} />
                    {/* <hr /> */}
                  </p>
                  <span>
                    Manage your inspection needs with our Digital Platform.
                  </span>
                </div>
              </Col>
              {data.map((item: DataItem, index: number) => {
                if (index === 2 || index === 3) {
                  return (
                    <Col md={12} lg={5} className="mt-5">
                      <div
                        onClick={() => {
                          handleClick(item, index);
                        }}
                        className={styles.text_only}
                      >
                        <div className={styles.text}>
                          <p>{item.head}</p>
                          <span>{item.label}</span>
                        </div>
                      </div>
                    </Col>
                  );
                } else {
                  return (
                    <Col md={12} lg={7} className={index > 0 ? "mt-5" : ""}>
                      <div
                        onClick={() => {
                          handleClick(item, index);
                        }}
                        className={styles.img_text}
                      >
                        <div className={styles.img_new}>
                          <img
                            src={
                              index === 0 ? first : index === 1 ? sec : three
                            }
                          />
                        </div>

                        <div className={styles.text}>
                          <p>{item.head}</p>
                          <span>{item.label}</span>
                        </div>
                      </div>
                    </Col>
                  );
                }
              })}
              {/* <Col md={12} lg={7}>
              <div className={styles.img_text}>
                <div className={styles.img_new}>
                  <img src={first} />
                </div>

                <div className={styles.text}>
                  <p>Add multiple projects and properties</p>
                  <span>
                    Set up your team and get the ability to add multiple
                    projects and properties for inspections.
                  </span>
                </div>
              </div>
            </Col>

            <Col md={12} lg={7} className="mt-5">
              <div className={styles.img_text}>
                <div className={styles.img_new}>
                  <img src={sec} />
                </div>

                <div className={styles.text}>
                  <p>Create appointments on the go</p>
                  <span>
                    Choose between a desktop or be on the move with our mobile
                    app.
                  </span>
                </div>
              </div>
            </Col>
            <Col md={12} lg={5} className="mt-5">
              <div className={styles.text_only}>
                <div className={styles.text}>
                  <p>Real time Tracking</p>
                  <span>
                    Get real time updates about how your inspection is
                    progressing.
                  </span>
                </div>
              </div>
            </Col>
            <Col md={12} lg={5} className="mt-5">
              <div className={styles.text_only}>
                <div className={styles.text}>
                  <p>Get detailed reporting</p>
                  <span>
                    Get drill down views and daily, monthly and weekly
                    reporting.
                  </span>
                </div>
              </div>
            </Col>
            <Col md={12} lg={7} className="mt-5">
              <div className={styles.img_text}>
                <div className={styles.img_new}>
                  <img src={three} />
                </div>

                <div className={styles.text}>
                  <p>In App customer service</p>
                  <span>Speak with a human and get help real time.</span>
                </div>
              </div>
            </Col> */}
            </>
          </Row>
          {/* <Row>
          <Col>
            <div className={styles.img_text}>
              <div>
                <img src={first} />
              </div>
              <div className={styles.text}>
                <p>Add multiple projects and properties</p>
                <span>
                  Create or Manage your inspections with Construction Inspection
                  Doctor, all of your data in one place.
                </span>
              </div>
            </div>
          </Col>
          <Col>
            <div className={styles.img_text}>
              <div>
                <img src={first} />
              </div>
              <div className={styles.text}>
                <p>Add multiple projects and properties</p>
                <span>
                  Create or Manage your inspections with Construction Inspection
                  Doctor, all of your data in one place.
                </span>
              </div>
            </div>
          </Col>
        </Row> */}
        </div>
      </Container>
      {modal && (
        <Modal
          items={dataMain}
          selected={selectIndex}
          setModal={setModal}
          data={data}
          setOpen={setOpen}
        />
      )}
    </div>
  );
};
export default Four;
